<template lang="pug">
div
    modal(v-show="isShowModal_",:titulo="'ACTUALIZACION ' + nameModulo.toUpperCase()" bindClass="col-md-4 col-sm-12" , @close="isShowModal_=false")
        div(slot='body')  
            .form-group
                .form-row
                    .col-md-12.col-sm-12
                        label Nombre
                        input.form-control.form-control-sm(v-model="parameter.NameExpressionRegulate")
                .form-row
                    .col-md-12.col-sm-12
                        label Expresion Regular
                        input.form-control.form-control-sm(v-model="parameter.ValidateExpressionRegulate")
                .form-row 
                    .col-md-12.col-sm-12
                        label Mensaje Alerta
                        input.form-control.form-control-sm(v-model="parameter.ValidateMessage")
        div(slot='footer')                      
            button.btn.btn-primary(@click="sendInfo()") Guardar
                       
</template>
<script>
import modal from "../../../complementos/modal.vue"
export default {
    props:{ 
        nameModulo:String,
        IsShowModal:Boolean,
        parameter:Object,
        apiWeb:Object
    },
    data(){
        return{ 
        }
    },
    components:{
        modal
    },
    computed:{
        isShowModal_ :{
                        get(){return this.IsShowModal },
                        set(val){this.$emit("update:IsShowModal",val)}
        } 
    },
    mounted(){
         
    },
    updated(){
        
    },
    methods:{   
        sendInfo(){
            if(this.validate()){
                this.$emit("update:parameter",this.parameter)            
                this.$emit("sendInfo",this.parameter)
            }         
        },
        validate(){ 
           if(this.parameter.NameExpressionRegulate=='' || this.parameter.NameExpressionRegulate==null ){
                this.$msgbox.show("Ingrese Nombre","Alerta")
                return false
            }
            else if(this.parameter.ValidateExpressionRegulate=='' || this.parameter.ValidateExpressionRegulate==null ){
                this.$msgbox.show("Ingrese Expresion","Alerta")
                return false
            }
            else if(this.parameter.ValidateMessage=='' || this.parameter.ValidateMessage==null ){
                this.$msgbox.show("Ingrese Mensaje de Validacion ","Alerta")
                return false
            }
            else{
                return true
            }
        }
    }

    
}
</script>